import { render } from "./HelloWorld.vue?vue&type=template&id=9125dd8c&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=9125dd8c&scoped=true&lang=css"

import exportComponent from "/Users/IBRAHIM/Desktop/eacompany/loughati_app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9125dd8c"]])

export default __exports__